import { render, staticRenderFns } from "./CenterViewEventTicketIssueHistory_Ap.vue?vue&type=template&id=8b7fb39a&scoped=true"
import script from "./CenterViewEventTicketIssueHistory_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventTicketIssueHistory_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventTicketIssueHistory_Ap.vue?vue&type=style&index=0&id=8b7fb39a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7fb39a",
  null
  
)

export default component.exports